import React, { ReactElement, useState, useCallback } from 'react';
import Logout, { IProps } from '../components/Logout/Logout';

export const useLogout = (props: IProps): [() => any, ReactElement] => {
    const [toggle, setToggle] = useState<boolean>(false);

    const onToggle = useCallback(() => setToggle((state) => !state), []);
    const onLogout = useCallback(async () => {
        if (typeof props.onLogout === 'function') {
            await props.onLogout();
        }
        onToggle();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [onToggle, <>{toggle && <Logout {...props} onClose={onToggle} onLogout={onLogout} />}</>];
};

export default useLogout;
